// extracted by css-extract-rspack-plugin
export default {"addressCell":"addressCell-2QJ85b"};